<script lang="ts">

import type ChartBar from './ChartBar';
import { CHART_COLORS } from './ChartLayer';
import type { ChartColor } from './ChartLayer';

/**
 * VChartBars — декларативный слой столбиков объёма VChart. Сам ничего не рендерит.
 *
 * Столбики живут на своей оси (справа) в нижней части графика, под ценами.
 *
 * @example
 * <VChartBars label="Объём заказов" color="green" :bars="orderVolumes"/>
 */
export default defineComponent({
  name: 'VChartBars',

  props: {
    /** Подпись в легенде */
    label: {
      type:     String,
      required: true,
    },

    color: {
      type:      String as PropType<ChartColor>,
      required:  true,
      validator: (v: string) => (CHART_COLORS as readonly string[]).includes(v),
    },

    bars: {
      type:     Array as PropType<ChartBar[]>,
      required: true,
    },
  },

  render() {
    return null;
  },
});
</script>
